import { FC, ReactNode } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface GridSectionHeroProps {
  className?: string;
  rightImg?: string;
  heading?: ReactNode;
  subHeading?: string;
  btnText?: string;
  imgHeight?: string;
  imgWidth?: string;
}

const GridSectionHero: FC<GridSectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
  imgWidth,
  imgHeight,
}) => {
  return (
    <div className={`nc-SectionHero relative ${className}`} data-nc-id="SectionHero">
      <div className="relative grid items-center grid-cols-1 text-center lg:grid-cols-2 lg:text-left lg:gap-x-20">
        <div className="flex justify-center mb-8 lg:justify-end lg:mb-0">
          <img className="w-full" src={rightImg || ""} alt="" style={{ width: imgWidth, height: imgHeight }} />
        </div>

        <div className="w-full space-y-5 xl:max-w-lg lg:space-y-7">
          <span className="block text-base xl:text-md text-neutral-6000 dark:text-white">{heading}</span>
          <span className="block text-base xl:text-md text-neutral-6000 dark:text-white">{subHeading}</span>

          {!!btnText && <ButtonPrimary href="/login">{btnText}</ButtonPrimary>}
        </div>
      </div>
    </div>
  );
};

export default GridSectionHero;
